"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_LOGGED_INC = void 0;
exports.TIME_LOGGED_INC = 5;
//# sourceMappingURL=constants.js.map